"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CouldNotDetermineUnit = exports.UnsupportedUnitConversion = exports.MissingDensity = exports.AggregationError = exports.LogLevel = void 0;
var LogLevel;
(function (LogLevel) {
    LogLevel["ERROR"] = "error";
    LogLevel["WARNING"] = "warning";
})(LogLevel || (exports.LogLevel = LogLevel = {}));
class AggregationError extends Error {
    /**
     * Set logLevel to LogLevel.WARNING to log as a warning instead of an error.
     */
    constructor(message, logLevel = LogLevel.ERROR) {
        super(message);
        this.name = this.constructor.name;
        this.logLevel = logLevel;
    }
}
exports.AggregationError = AggregationError;
class MissingDensity extends AggregationError {
    constructor(sourceUnit, targetUnit, chemicalId, chemicalName) {
        super("Conversions between mass and volume require a density.");
        // create the RFC record for these chemicals
        this.logLevel = LogLevel.WARNING;
        if (chemicalId) {
            this.chemicalId = chemicalId;
            this.aggregatorError = `We were unable to aggregate this chemical because we cannot convert ${sourceUnit} to ${targetUnit} for chemical: ${chemicalName} without a density.`;
        }
        else {
            this.aggregatorError = `We were unable to aggregate this chemical because we cannot convert ${sourceUnit} to ${targetUnit} without a density.`;
        }
    }
}
exports.MissingDensity = MissingDensity;
class UnsupportedUnitConversion extends AggregationError {
    constructor(sourceUnit, targetUnit, chemicalId, chemicalName) {
        super(`Conversions from ${sourceUnit} to ${targetUnit} are currently not supported.`);
        if (chemicalId) {
            this.chemicalId = chemicalId;
            this.aggregatorError = `We were unable to aggregate this chemical because we cannot accurately convert ${sourceUnit} to ${targetUnit} at this time for chemical: ${chemicalName}.`;
        }
        else {
            // this.chemicalId = chemicalId ? chemicalId : null;
            // create the RFC record for these chemicals
            this.aggregatorError = `We were unable to aggregate this chemical because we cannot accurately convert ${sourceUnit} to ${targetUnit} at this time.`;
        }
    }
}
exports.UnsupportedUnitConversion = UnsupportedUnitConversion;
class CouldNotDetermineUnit extends AggregationError {
    constructor(missingUnit) {
        super(`Unable to determine ${missingUnit}Unit`);
        this.logLevel = LogLevel.WARNING;
        this.aggregatorError = `We were unable to aggregate this chemical because we cannot determine the unit to convert ${missingUnit}.`;
    }
}
exports.CouldNotDetermineUnit = CouldNotDetermineUnit;
//# sourceMappingURL=errors.js.map